module.exports = __webpack_public_path__ + "img/jt1.2184c260.png";